import React from 'react';
import PropTypes from 'prop-types';

/**
 * MatchaDog — pixel art representation of Matcha the golden retriever.
 *
 * Rendered as a group of SVG rects.  The bobbing idle animation is driven
 * by the `.mBob` class defined in animations.css.
 *
 * This component must be rendered *inside* an <svg> element.
 *
 * @param {object} props
 * @param {number} props.x - SVG x-coordinate for the dog's origin.
 * @param {number} props.y - SVG y-coordinate for the dog's origin.
 */
function MatchaDog({ x, y }) {
  return (
    <g
      transform={`translate(${x},${y})`}
      style={{ animation: 'mBob 2.5s ease-in-out infinite' }}
      aria-label="Matcha the dog"
      role="img"
    >
      {/* Body */}
      <rect x="0"  y="8"  width="18" height="11" fill="#d4a855" />
      {/* Head */}
      <rect x="12" y="1"  width="13" height="11" fill="#d4a855" />
      {/* Ears */}
      <rect x="10" y="-1" width="6"  height="6"  fill="#c4903a" />
      <rect x="18" y="-1" width="6"  height="6"  fill="#c4903a" />
      {/* Snout */}
      <rect x="22" y="5"  width="6"  height="4"  fill="#e8c080" />
      {/* Eye */}
      <rect x="14" y="3"  width="3"  height="3"  fill="#2a1a08" />
      {/* Nose */}
      <rect x="24" y="5"  width="2"  height="2"  fill="#1a0808" />
      {/* Tail */}
      <rect x="-5" y="4"  width="6"  height="5"  fill="#d4a855" />
      <rect x="-8" y="1"  width="5"  height="5"  fill="#c4903a" />
      {/* Front legs */}
      <rect x="2"  y="18" width="5"  height="7"  fill="#c4903a" />
      <rect x="10" y="18" width="5"  height="7"  fill="#c4903a" />
    </g>
  );
}

MatchaDog.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
};

export default MatchaDog;
